import fetch from '@/apiconfig/index';

export function itemStatusHttpAction(param) {
  return fetch({
    url: '/api/companystaff/individualBusiness/checkIndividualBusinessStatus/' + param,
    method: 'get',
  });
}